"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ForeachStatement = /** @class */ (function () {
    function ForeachStatement(identifier, collection, query) {
        this.identifier = identifier;
        this.collection = collection;
        this.query = query;
    }
    ForeachStatement.prototype.toString = function () {
        return "FOREACH ( " + this.identifier + " IN $" + this.collection + " | " + this.query.toString() + " )";
    };
    return ForeachStatement;
}());
exports.default = ForeachStatement;
